<template>
  <li v-if="esPlantilla" class="extras-mg-plantilla">
    <Button type="primary" size="regular" icon="iconoir-copy" @click="abrir">
      Usar esta plantilla
    </Button>
    <Modal ref="modal" :small="true" @show="cargar">
      <h2 class="box__title">Usar «{{ table.name }}»</h2>
      <p class="extras-mg-plantilla__texto">
        Se copia a una base tuya con sus columnas, opciones y vistas, sin las filas de ejemplo.
      </p>
      <Error :error="error"></Error>
      <div v-if="cargando" class="loading"></div>
      <p v-else-if="!destinos.length" class="extras-mg-plantilla__texto">
        No tienes ninguna base donde puedas crear tablas. Pídele a tu admin que te la copie.
      </p>
      <form v-else @submit.prevent="usar">
        <FormGroup label="¿En qué base?" small-label required class="margin-bottom-2">
          <Dropdown v-model="baseId" :show-search="destinos.length > 6" fixed-items>
            <DropdownItem
              v-for="d in destinos"
              :key="d.id"
              :name="d.nombre"
              :value="d.id"
              :description="d.espacio"
            ></DropdownItem>
          </Dropdown>
        </FormGroup>
        <FormGroup label="Nombre de la tabla nueva" small-label required class="margin-bottom-2">
          <FormInput v-model="nombre" maxlength="255" :disabled="copiando" />
        </FormGroup>
        <div class="extras-mg-plantilla__pie">
          <Button type="primary" :loading="copiando" :disabled="copiando || !baseId || !nombre.trim()">
            Crear copia
          </Button>
        </div>
      </form>
    </Modal>
  </li>
</template>

<script>
import Button from '@baserow/modules/core/components/Button.vue'
import error from '@baserow/modules/core/mixins/error'
import PlantillasService from '@extras_mg/services/plantillas'

// Cuál es la base de plantillas no cambia mientras la página está abierta: se
// pregunta una vez y lo comparten todas las tablas que se abran.
let baseDePlantillas = null

/**
 * "Usar esta plantilla", en la barra de las tablas de la base de plantillas
 * (ver extras_mg/plantillas). En cualquier otra tabla no pinta nada.
 *
 * Las bases a las que se puede copiar las decide el servidor (donde puedes
 * crear tablas); se piden al abrir, por si te cambiaron los permisos.
 */
export default {
  name: 'UsarPlantilla',
  components: { Button },
  mixins: [error],
  props: {
    database: { type: Object, required: false, default: null },
    table: { type: Object, required: true },
    view: { type: Object, required: false, default: null },
  },
  data() {
    return { base: null, destinos: [], baseId: null, nombre: '', cargando: false, copiando: false }
  },
  computed: {
    esPlantilla() {
      return !!this.base && this.table.database_id === this.base
    },
  },
  async mounted() {
    try {
      baseDePlantillas = baseDePlantillas || PlantillasService(this.$client).leer()
      const { data } = await baseDePlantillas
      this.base = data.base
    } catch (e) {
      baseDePlantillas = null
    }
  },
  methods: {
    abrir() {
      this.nombre = this.table.name
      this.$refs.modal.show()
    },
    async cargar() {
      this.hideError()
      this.cargando = true
      try {
        const { data } = await PlantillasService(this.$client).leer()
        this.destinos = data.destinos
        if (!this.destinos.some((d) => d.id === this.baseId)) {
          this.baseId = this.destinos[0]?.id ?? null
        }
      } catch (e) {
        this.handleError(e)
      } finally {
        this.cargando = false
      }
    },
    async usar() {
      this.hideError()
      this.copiando = true
      try {
        const { data } = await PlantillasService(this.$client).usar(this.table.id, this.baseId, this.nombre.trim())
        const destino = this.$store.getters['application/get'](data.database_id)
        if (destino) {
          await this.$store.dispatch('table/forceUpsert', { database: destino, data })
        }
        this.$refs.modal.hide()
        this.$router.push({
          name: 'database-table',
          params: { databaseId: data.database_id, tableId: data.id },
        })
      } catch (e) {
        this.handleError(e)
      } finally {
        this.copiando = false
      }
    },
  },
}
</script>

<style lang="scss">
.extras-mg-plantilla__texto {
  margin-bottom: 16px;
  font-size: 13px;
  line-height: 1.5;
}

.extras-mg-plantilla__pie {
  display: flex;
  justify-content: flex-end;
}
</style>
